import React from "react";
import ReactDOM from "react-dom/client";
import {ChakraProvider} from "@chakra-ui/react";
import {theme} from "./theme";
import { BrowserRouter } from "react-router-dom";
import App from "./routes";

const root = ReactDOM.createRoot(
	document.getElementById("root")!,
);

root.render(
	<React.StrictMode>
		<ChakraProvider theme={theme}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</ChakraProvider>
	</React.StrictMode>,
);
